<template>
  <div style="width: 1540px; overflow: hidden;">
    <div style="float: left; width: 740px; height: 100%; position: relative; margin-right: 60px;">
      <heatmap
        ref="heatmapA"
        mode="aType"
        :aid="abAid"
        :orgAid="aid"
        :captureAid="aid"
        :abData="abData.a"
        :abTestType="abTestType"
        :syncedOptions.sync="syncedOptions"
        :userActionData="userActionDataA"
        :isEditStatus="isEditStatus"
        :isDownloading="isDownloading"
        @onDownloading="onDownloading"
        @onLoadingABSuccess="() => this.loadedHeatmapCount++"
        @onUserActionDataChange="userActionDataA = $event"/>
    </div>
    <div class="line__divide icon--dash-line">
      <span>{{ $t('common.versus') }}</span>
    </div>
    <div style="float: left; width: 740px; height: 100%; position: relative;">
      <heatmap
        ref="heatmapB"
        mode="bType"
        :aid="abAid"
        :orgAid="aid"
        :abData="abData.b"
        :abTestType="abTestType"
        :syncedOptions.sync="syncedOptions"
        :userActionData="userActionDataB"
        :isEditStatus="isEditStatus"
        @onDownloading="onDownloading"
        @onLoadingABSuccess="() => this.loadedHeatmapCount++"
        @onUserActionDataChange="userActionDataB = $event"/>
    </div>
    <download-error :isDownloading="isDownloading"
                    @onDownloading="onDownloading"></download-error>
  </div>
</template>

<script>
import { getScrollSyncFn } from '@/libs/heatmap-helper'
import Heatmap from '@/components/heatmap'
import DownloadError from '@/components/heatmap/HeatmapDownloadError'

export default {
  name: 'ABreportHeatmap',
  components: {
    Heatmap,
    DownloadError
  },
  props: [
    'isSynced',
    'aData',
    'bData',
    'isEditStatus'
  ],
  data () {
    return {
      syncedOptions: null,
      userActionDataA: null,
      userActionDataB: null,
      isDownloading: false,
      scrollHandler: null,
      loadedHeatmapCount: 0 // When it's 2, loading complete
    }
  },
  computed: {
    aid () {
      return this.$route.params.aid
    },
    abAid () {
      return this.$route.params.abAid
    },
    abData () {
      return {
        a: this.aData,
        b: this.bData
      }
    },
    abTestType () {
      return this.bData.abTestType
    }
  },
  watch: {
    isSynced (value) {
      if (value) {
        this.syncedOptions = {}
        this.bindScrollSyncEvent()
      } else {
        this.syncedOptions = null
        this.unbindScrollSyncEvent()
      }
    },
    loadedHeatmapCount (value) {
      if (value >= 2) {
        if (this.isSynced) {
          this.syncedOptions = {}
          this.bindScrollSyncEvent()
        } else {
          this.syncedOptions = null
          this.unbindScrollSyncEvent()
        }
      }
    }
  },
  beforeDestroy () {
    this.unbindScrollSyncEvent()
  },
  methods: {
    bindScrollSyncEvent () {
      if (this.scrollHandler === null) {
        const containerA = this.$refs.heatmapA.$refs.container
        const containerB = this.$refs.heatmapB.$refs.container
        this.scrollHandler = getScrollSyncFn(containerA, containerB)
        containerA.addEventListener('scroll', this.scrollHandler, false)
        containerB.addEventListener('scroll', this.scrollHandler, false)
      }
    },
    unbindScrollSyncEvent () {
      if (this.scrollHandler) {
        const containerA = this.$refs.heatmapA.$refs.container
        const containerB = this.$refs.heatmapB.$refs.container
        containerA.removeEventListener('scroll', this.scrollHandler)
        containerB.removeEventListener('scroll', this.scrollHandler)
        this.scrollHandler = null
      }
    },
    onDownloading (value) {
      this.isDownloading = value
    }
  }
}
</script>

<style lang="scss" scoped>
.content__heatmap {
  position: relative;
  .line__divide {
    @include positionXYcenter;
    left: calc(50% - 15px);
    width: 2px;
    height: 100%;
    span {
      position: absolute;
      top: 78px;
      transform: translateX(-50%);
      display: inline-block;
      background-color: #F4F4F1;
      font-weight: bold;
      line-height: 1;
      text-align: center;
      padding: 9px 0;
      font-size: 15px;
      color: #ec0047;
    }
  }
}
.popup__error {
  @include positionXYcenter;
  width: 430px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  padding: 50px 30px 25px;
  box-sizing: border-box;
  overflow: hidden;
  text-align: center;

  .title {
    margin-top: 15px;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    color: #444444;
  }

  .desc {
    margin-top: 15px;
    font-size: 14px;
    text-align: center;
    color: #2f2f2f;
  }

  .ui-btn {
    margin-top: 60px;
  }
}
</style>
